import React, { useState, useEffect, useContext } from 'react';


import SimpleTable from '../../components/tables/simpleTable';

import TrashModal from '../../components/modals/trashModal';
import RecoverModal from '../../components/modals/recoverModal';
import AddModal from '../../components/modals/addModal';
import EditModal from '../../components/modals/editModal';
import DeleteModal from '../../components/modals/deleteModal';

import SearchFilter from '../../components/filters/search';
import CustomButton from '../../components/buttons/customButton';
import IsActiveFilter from '../../components/filters/isActive';
import AddButton from '../../components/buttons/addButton';
import DataFilter from '../../components/filters/dataFilter';
import DatePicker from '../../components/filters/datePicker';

import TabsPermission from './crud/tabsPermission';
import PagesPermission from './crud/pagesPermission';
import ActionsPermission from './crud/actionsPermission';

import { FiRotateCcw, FiPrinter } from "react-icons/fi";

import { FaPlus } from "react-icons/fa";

import Loader from '../../components/loader/loader';
import { isActiveFormatter, isActiveTextFormatter } from '../../components/formatters/defFormatter';
import { dateFormatter } from '../../dynamic/dateFormatter';
import toast from 'react-hot-toast';

import { Space, Input, Tag, Button, Tabs } from 'antd';


import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcViewDetails, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiBarcodeReader } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../init/getData';




function Role(props) {

  let { } = props;


  const { userData, yearData, companyId, api, refData, warehouseData, mainCurrency, secondaryCurrency,
    auxAccountData, companyData, branchData } = useContext(DataContext);
  const userRole = userData.role;
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  const createdBy = parseInt(userData.id);

  const today = new Date().toISOString().split('T')[0];

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);
  const [filter, setFilter] = useState({ search: '' });

  const [showAddModal, setShowAddModal] = useState(false);
  const [showTrashModal, setShowTrashModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const [showTabPermissionModal, setShowTabPermissionModal] = useState(false);
  const [showPagePermissionModal, setShowPagePermissionModal] = useState(false);
  const [showRoleActionsModal, setShowRoleActionsModal] = useState(false);


  const [defaultwarehouse, setDefaultwarehouse] = useState([]);
  const [warehouseSale, setwarehouseSale] = useState([]);
  const [role, setRole] = useState([]);

  const table = 'role';
  const title = 'Role';

  useEffect(() => {
    fetchRefData();
  }, []);


  const loggedIncompanyData = companyData.filter(e => e.id == companyId)

  const currencyOptions = [
    { value: mainCurrency.id, label: mainCurrency.code },
    { value: secondaryCurrency.id, label: secondaryCurrency.code },
  ]

  const fetchRefData = async () => {
    try {
      setIsLoading(true);
      const dataArray = ['warehouse', 'auxAccount', 'branch', 'company', 'year', 'currency']
      await refData(dataArray, companyId);
      setIsLoading(false);
    } catch (error) {
      console.error('Error refreshing data Contact Support');
    }
  };

  // warehouse Options
  const warehouseOptions = warehouseData?.map(item => ({
    value: item.id,
    label: item.name,
  }))

  // company Options
  const companyOptions = companyData?.map(item => ({
    value: item.id,
    label: item.name,
  }))

  // year Options
  const yearOptions = yearData?.map(item => ({
    value: item.id,
    label: item.year,
  }))



  // branch Options
  const branchOptions = branchData?.map(item => ({
    value: item.id,
    label: item.name,
  }))


  // Cash Account Options
  const accountOptions = auxAccountData?.map(item => ({
    value: item.id,
    label: (item?.parent?.accountId ? item?.parent?.accountId + '.' : '') + item.accountId + ' ' + item.english,
  }));
  const loadAccountOptions = (inputValue, callback) => {
    const filteredOptions = inputValue ? accountOptions.filter(option =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())) : [];
    callback(filteredOptions);
  };


  const addModal = () => {
    setIdRow({});
    resetForm();
    setShowAddModal(!showAddModal);
  }

  const resetForm = () => {
    setRole({})
    setDefaultwarehouse([])
    setwarehouseSale([])
  }

  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  const recoverModal = (e) => {
    if (!showRecoverModal) {
      setIdRow(e);
    }
    setShowRecoverModal(!showRecoverModal);
  }

  const trashModal = (e) => {
    if (!showTrashModal) {
      setIdRow(e);
    }
    setShowTrashModal(!showTrashModal);
  }

  const deleteModal = (e) => {
    if (!showDeleteModal) {
      setIdRow(e);
    }
    setShowDeleteModal(!showDeleteModal);
  }

  const editModal = (e) => {
    if (!showEditModal) {
      setIdRow(e);
    }
    setShowEditModal(!showEditModal);
  }

  const tabPermissionModal = (e) => {
    if (!showTabPermissionModal) {
      setIdRow(e);
    }
    setShowTabPermissionModal(!showTabPermissionModal);
  }

  const pagePermissionModal = (e) => {
    if (e != undefined) {
      setIdRow(e);
    }
    setShowPagePermissionModal(!showPagePermissionModal);
  }

  const roleActionModal = (e) => {
    if (e != undefined) {
      setIdRow(e);
    }
    setShowRoleActionsModal(!showRoleActionsModal);
  }

  // idRow Change
  useEffect(() => {
    setRole(
      {
        name: idRow?.name || '',
        defaultCurrencyId: idRow?.defaultCurrencyId || null,
        companyId: idRow?.companyId || null,
        yearId: idRow?.yearId || null,

        branchId: idRow?.branchId || null,
        warehouseId: idRow?.warehouseId || null,

        cashAccountId: idRow?.cashAccountId || null,
        varianceAccountId: idRow?.varianceAccountId || null,
      }
    )
  }, [idRow]);

  // handle select change
  const handleSelectChange = (selectedOption, name) => {
    setRole((prev) => ({
      ...prev,
      [name]: selectedOption?.value ?? null,
    }));
  };


  // Generic handler for input changes
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    if (value === 'true' || value === 'false') {
      value = JSON.parse(value)
    }
    setRole((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  //Excel Data
  const getExcelData = (data) => {

    const transformedData = [];
    data.forEach(item => {

      const newItem = {
        ID: item.id,
        Name: item.name,
        Currency: item.defaultCurrency?.code,
        Company: item.company?.name,
        Year: item.year?.year,
        Branch: item.branch?.name,
        Warehouse: item.warehouse?.name,
        Cash: item.cashAccount?.english,
        Variance: item.varianceAccount?.english,
        Status: isActiveTextFormatter(item.isActive),
      };

      transformedData.push(newItem);
    });

    return { transformedData };
  };



  let newColumnDefs = [
    { title: 'ID', dataIndex: 'id', width: '5%' },
    { title: 'Name', dataIndex: 'name' },
    { title: 'Currency', dataIndex: 'defaultCurrency', render: (defaultCurrency) => (defaultCurrency?.code) },
    { title: 'Company', dataIndex: 'company', render: (company) => (company?.name) },
    { title: 'Year', dataIndex: 'year', render: (year) => (year?.year) },
    { title: 'Branch', dataIndex: 'branch', render: (branch) => (branch?.name) },
    { title: 'Warehouse', dataIndex: 'warehouse', render: (warehouse) => (warehouse?.name) },
    { title: 'Cash', dataIndex: 'cashAccount', render: (cashAccount) => (cashAccount?.english) },
    { title: 'Variance', dataIndex: 'varianceAccount', render: (variance) => (variance?.english) },
    { title: 'Status', dataIndex: 'isActive', render: isActiveFormatter },
  ];

  useEffect(() => {

    newColumnDefs.push(
      {
        title: 'Tabs',
        width: '5%',
        render: (_, record) => (
          <FcViewDetails onClick={e => tabPermissionModal(record)} size={20} style={{ cursor: 'pointer' }} />
        ),
      },
      {
        title: 'Pages',
        width: '5%',
        render: (_, record) => (
          <FcRules onClick={e => pagePermissionModal(record)} size={20} style={{ cursor: 'pointer' }} />
        ),
      },
      {
        title: 'Actions',
        width: '5%',
        render: (_, record) => (
          <FcFlowChart onClick={e => roleActionModal(record)} size={20} style={{ cursor: 'pointer' }} />
        ),
      },
      {
        title: 'Edt',
        width: '5%',
        render: (_, record) => (
          <FiEdit size={16} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => editModal(record)} />
        ),
      },
      {
        title: 'Void',
        width: '5%',
        render: (_, record) => (record.isActive ? (
          <BiSolidTrash size={18} style={{ cursor: 'pointer', color: '#e6434f' }} onClick={() => trashModal(record)} />
        ) : <FcUndo size={18} style={{ cursor: 'pointer', color: '#e6434f' }} onClick={() => recoverModal(record)} />
        )
      }
    );

    setColumnDefs(newColumnDefs);

  }, []);

  const formView = (
    <div style={{ userSelect: 'none' }}>

      <Row className="mb-3">
        {/* Name  */}
        <Col>
          <Form.Label className='formLabel'>Name<span style={{ color: 'red' }}> *</span></Form.Label>
          <Form.Control type="text" name='name'
            value={role.name}
            onChange={handleInputChange}
            required
          />
        </Col>

        <Col>
          <Form.Label>Currency</Form.Label>
          <Select
            options={currencyOptions}
            isSearchable={true}
            placeholder="select"
            onChange={(e) => handleSelectChange(e, 'defaultCurrencyId')}
            value={currencyOptions?.find(option => option.value === role.defaultCurrencyId) || null}
            required
          />
        </Col>
      </Row>

      <Row className="mb-3">
        <Col>
          <Form.Label>Company</Form.Label>
          <Select
            isClearable={true}
            options={companyOptions}
            isSearchable={true}
            placeholder="select"
            onChange={(e) => handleSelectChange(e, 'companyId')}
            value={companyOptions?.find(option => option.value === role.companyId) || null}
          />
        </Col>

        <Col>
          <Form.Label>Year</Form.Label>
          <Select
            isClearable={true}
            options={yearOptions}
            isSearchable={true}
            placeholder="select"
            onChange={(e) => handleSelectChange(e, 'yearId')}
            value={yearOptions?.find(option => option.value === role.yearId) || null}
          />
        </Col>
      </Row>

      <Row className="mb-3" style={{ marginTop: '2%' }}>


        <Col>
          <Form.Label>Branch</Form.Label>
          <Select
            options={branchOptions}
            isSearchable={true}
            placeholder="select"
            onChange={(e) => handleSelectChange(e, 'branchId')}
            value={branchOptions?.find(option => option.value === role.branchId) || []}
            required
          />
        </Col>

        <Col>
          <Form.Label>Sales warehouse</Form.Label>
          <Select
            options={warehouseOptions}
            isSearchable={true}
            placeholder="select"
            onChange={(e) => handleSelectChange(e, 'warehouseId')}
            value={warehouseOptions?.find(option => option.value === role.warehouseId) || []}
            required
          />
        </Col>
      </Row>


      <Row className="mb-5">

        <Col>
          <Form.Label> Cash Account<span style={{ color: 'red' }}>*</span> </Form.Label>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}
            defaultOptions={[]}
            onChange={(e) => handleSelectChange(e, 'cashAccountId')}
            value={accountOptions?.find(option => option.value === role.cashAccountId) || []}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Col>



        <Col>
          <Form.Label> Variance Account<span style={{ color: 'red' }}>*</span> </Form.Label>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}
            defaultOptions={[]}
            onChange={(e) => handleSelectChange(e, 'varianceAccountId')}
            value={accountOptions?.find(option => option.value === role.varianceAccountId)}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Col>
      </Row>


      <Row className="mb-3">
        <p>Note: data showen is for logged in company</p>
      </Row>

    </div >);




  const modalFooter = (
    <div>
    </div>
  );

  const tableFooter = (
    <></>
  );

  const refreshButton = async () => {
    await fetchRefData();
    refreshTableFunction();

  }


  return (
    <div>

      {isLoading &&
        <Loader />
      }


      <Row className='g-0 mb-3'>

        <Col md={2}>
          <SearchFilter setFilter={setFilter} />
        </Col>

        <Col md={8}>
        </Col>

        <Col md={2} className="d-flex justify-content-end">
          <Button onClick={refreshTableFunction}>
            <FiPrinter size={18} />
          </Button>
          <Button onClick={refreshTableFunction}>
            <FiRotateCcw size={18} />
          </Button>
          <Button
            style={{ backgroundColor: '#23576a', color: 'white' }}
            onClick={() => addModal(null)} >Add</Button>
        </Col>

      </Row>


      {!isLoading &&
        <>




          <SimpleTable
            filter={filter}
            showAddModal={showAddModal}
            addModal={addModal}
            table={table}
            title={title}
            columnDefs={columnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            refreshTable={refreshTable}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
          />

          <TrashModal
            showModal={showTrashModal}
            toggleModal={trashModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            data={{ id: idRow.id }}
          />


          <RecoverModal
            showModal={showRecoverModal}
            toggleModal={recoverModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            data={{ id: idRow?.id }}
          />

          <AddModal
            showModal={showAddModal}
            toggleModal={addModal}
            formView={formView}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            size={'lg'}
            resetForm={resetForm}
            footer={modalFooter}
            api={api}
            data={{ role }}
          />

          <EditModal
            showModal={showEditModal}
            toggleModal={editModal}
            formView={formView}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            size={'lg'}
            footer={modalFooter}
            api={api}
            data={{ id: idRow?.id, role }}
          />



          <TabsPermission showModal={showTabPermissionModal} toggleModal={tabPermissionModal} tittle={'Role'} refreshTable={refreshTableFunction} idRow={idRow} />
          <PagesPermission showModal={showPagePermissionModal} toggleModal={pagePermissionModal} tittle={'Role'} refreshTable={refreshTableFunction} idRow={idRow} />
          <ActionsPermission showModal={showRoleActionsModal} toggleModal={roleActionModal} tittle={'Role'} refreshTable={refreshTableFunction} idRow={idRow} />



        </>
      }

    </div>
  )
}

export default Role;
